var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.getComputedClassName},[(!_vm.chip)?_c('span',{staticClass:"counter__text"},[_vm._v("Clue "+_vm._s(_vm.count))]):_vm._e(),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"counter__icon"},[_c('img',{attrs:{"src":require("@/assets/images/activities/spelling/balloon-blue.png"),"alt":"DigiPal icon"}})])
}]

export { render, staticRenderFns }